import { Container, Modal, Table } from "react-bootstrap";
import "../css/InfoModal.css";

const StructureDataModal = ({ structureData, show, setShow }) => {
  const closeModal = () => {
    setShow(false);
  };

  return (
    <Container>
      <Modal
        show={show}
        onHide={closeModal}
        dialogClassName="info-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header
          style={{ border: "none", flexShrink: 0 }}
          className="ms-2 me-2"
          closeButton
        >
          <Modal.Title>Structure: {structureData.structureName}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            overflowY: "auto",
            flex: 1,
            padding: "1rem",
          }}
        >
          <div className="info-modal-table-scroll">
            <Table striped bordered hover>
              <tbody>
                <tr>
                  <td className="fw-bold text-start">Structure ID</td>
                  <td className="text-start">{structureData.structureId}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Name</td>
                  <td className="text-start">{structureData.structureName}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Address One</td>
                  <td className="text-start">
                    {structureData.structureAddressOne}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Address Two</td>
                  <td className="text-start">
                    {structureData.structureAddressTwo}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">City</td>
                  <td className="text-start">{structureData.structureCity}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Postal Code</td>
                  <td className="text-start">
                    {structureData.structurePostalCode}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">State</td>
                  <td className="text-start">{structureData.structureState}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">State Abbreviation</td>
                  <td className="text-start">
                    {structureData.structureStateAbbr}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Country</td>
                  <td className="text-start">
                    {structureData.structureCountry}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Country Code</td>
                  <td className="text-start">
                    {structureData.structureCountryCode}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Business Region</td>
                  <td className="text-start">
                    {structureData.structureBusinessRegionName}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Geo Region</td>
                  <td className="text-start">
                    {structureData.structureGeoRegion}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Latitude</td>
                  <td className="text-start">{structureData.structureLat}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Longitude</td>
                  <td className="text-start">{structureData.structureLon}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Ownership</td>
                  <td className="text-start">
                    {structureData.structureOwnership}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Status</td>
                  <td className="text-start">
                    {structureData.structureStatus}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold text-start">Floor Count</td>
                  <td className="text-start">
                    {structureData.structureFloorCount}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default StructureDataModal;
